import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import clsx from "clsx";

import { setCountry } from "../../store/languageSlice/languageSlice";

import CountriesDropdown from "../countries-dropdown/CountriesDropdown";

import alFlag from "../../countries-icons/al.svg";
import atFlag from "../../countries-icons/at.svg";
import beFlag from "../../countries-icons/be.svg";
import bgFlag from "../../countries-icons/bg.svg";
import chFlag from "../../countries-icons/ch.svg";
import cyFlag from "../../countries-icons/cy.svg";
import czFlag from "../../countries-icons/cz.svg";
import deFlag from "../../countries-icons/de.svg";
import esFlag from "../../countries-icons/es.svg";
import euFlag from "../../countries-icons/eu.svg";
import frFlag from "../../countries-icons/fr.svg";
import gbFlag from "../../countries-icons/gb.svg";
import grFlag from "../../countries-icons/gr.svg";
import hrFlag from "../../countries-icons/hr.svg";
import huFlag from "../../countries-icons/hu.svg";
import itFlag from "../../countries-icons/it.svg";
import luFlag from "../../countries-icons/lu.svg";
import mcFlag from "../../countries-icons/mc.svg";
import mtFlag from "../../countries-icons/mt.svg";
import nlFlag from "../../countries-icons/nl.svg";
import plFlag from "../../countries-icons/pl.svg";
import ptFlag from "../../countries-icons/pt.svg";
import roFlag from "../../countries-icons/ro.svg";
import rsFlag from "../../countries-icons/rs.svg";
import skFlag from "../../countries-icons/sk.svg";
import trFlag from "../../countries-icons/tr.svg";

import styles from "./countries.module.scss";

const countryImages = {
  albania: alFlag,
  austria: atFlag,
  belgium: beFlag,
  bulgaria: bgFlag,
  switzerland: chFlag,
  cyprus: cyFlag,
  czechia: czFlag,
  germany: deFlag,
  spain: esFlag,
  europe: euFlag,
  france: frFlag,
  "great-britain": gbFlag,
  greece: grFlag,
  croatia: hrFlag,
  hungary: huFlag,
  italy: itFlag,
  luxembourg: luFlag,
  monaco: mcFlag,
  malta: mtFlag,
  netherlands: nlFlag,
  poland: plFlag,
  portugal: ptFlag,
  romania: roFlag,
  serbia: rsFlag,
  slovakia: skFlag,
  turkiye: trFlag,
};

const Countries = ({ countriesInfo }) => {
  const { lang, country } = useParams();

  const dispatch = useDispatch();

  const { mainWords } = useSelector((state) => state.language);

  const selectCountry = (countryName) => {
    dispatch(setCountry(countryName));
  };

  return (
    <div className={styles.countries}>
      <a href="#price" className={styles.button_price}>
        {mainWords.textBtnPrice}
        {/* <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{marginBottom: "-1px"}}
        >
          <path
            d="M12.333 1.40528C13.5492 2.10743 14.5591 3.11733 15.2612 4.33348C15.9634 5.54964 16.333 6.92919 16.333 8.33348C16.333 9.73778 15.9633 11.1173 15.2612 12.3335C14.559 13.5496 13.5491 14.5595 12.3329 15.2616C11.1168 15.9638 9.73718 16.3334 8.33288 16.3334C6.92858 16.3334 5.54902 15.9637 4.33288 15.2615C3.11673 14.5593 2.10684 13.5494 1.40472 12.3333C0.702592 11.1171 0.332972 9.73752 0.333008 8.33323L0.337008 8.07403C0.38181 6.69243 0.783846 5.34602 1.50392 4.16605C2.22399 2.98609 3.23753 2.01284 4.44572 1.34119C5.65391 0.669536 7.01553 0.322405 8.39781 0.333638C9.7801 0.344871 11.1359 0.714083 12.333 1.40528ZM8.33301 3.53326C6.69141 3.53326 5.31861 4.69246 4.69381 6.33324H4.33301C4.1291 6.33347 3.93298 6.41155 3.78471 6.55152C3.63644 6.6915 3.54722 6.8828 3.53527 7.08635C3.52332 7.28991 3.58955 7.49034 3.72042 7.6467C3.85129 7.80306 4.03693 7.90355 4.23941 7.92763L4.34661 7.93323C4.32832 8.19958 4.32832 8.46688 4.34661 8.73323H4.33301C4.12083 8.73323 3.91735 8.81751 3.76732 8.96754C3.61729 9.11757 3.53301 9.32105 3.53301 9.53322C3.53301 9.74539 3.61729 9.94887 3.76732 10.0989C3.91735 10.2489 4.12083 10.3332 4.33301 10.3332H4.69461C5.31861 11.9756 6.69141 13.1332 8.33301 13.1332C9.24581 13.1332 10.1066 12.7676 10.8002 12.1172C10.9551 11.9721 11.046 11.7714 11.0529 11.5592C11.0598 11.3471 10.9821 11.1409 10.837 10.986C10.6919 10.8311 10.4912 10.7402 10.279 10.7333C10.0669 10.7264 9.8607 10.8041 9.70581 10.9492C9.29861 11.3316 8.82421 11.5332 8.33301 11.5332C7.59541 11.5332 6.91221 11.0708 6.46501 10.334L7.53301 10.3332C7.74518 10.3332 7.94866 10.2489 8.09869 10.0989C8.24872 9.94887 8.33301 9.74539 8.33301 9.53322C8.33301 9.32105 8.24872 9.11757 8.09869 8.96754C7.94866 8.81751 7.74518 8.73323 7.53301 8.73323H5.95141C5.92639 8.46715 5.92639 8.19931 5.95141 7.93323H7.53301C7.74518 7.93323 7.94866 7.84895 8.09869 7.69892C8.24872 7.54889 8.33301 7.34541 8.33301 7.13324C8.33301 6.92107 8.24872 6.71759 8.09869 6.56756C7.94866 6.41753 7.74518 6.33324 7.53301 6.33324H6.46421C6.91221 5.59645 7.59541 5.13325 8.33301 5.13325C8.82501 5.13325 9.29941 5.33485 9.70661 5.71725C9.8615 5.86237 10.0677 5.94003 10.2798 5.93313C10.492 5.92623 10.6927 5.83533 10.8378 5.68045C10.9829 5.52556 11.0606 5.31937 11.0537 5.10723C11.0468 4.89509 10.9559 4.69438 10.801 4.54926C10.1074 3.89966 9.24661 3.53326 8.33301 3.53326Z"
            fill="white" className={styles.icon_btn}
          />
        </svg> */}
      </a>
      <div className={clsx(styles.wrapper, "flex-between")}>
        {countriesInfo.map((el, i) => {
          let key = Object.keys(el)[0];
          return (
            <Link
              to={`/${lang}/${key}`}
              key={i}
              className={clsx(
                styles.country,
                key === country ? styles.checked : ""
              )}
              title={el[key][0]}
              onClick={() => selectCountry(key)}
            >
              <img src={countryImages[key]} alt={el[key][0]} />
              <div>{el[key][2].toUpperCase()}</div>
            </Link>
          );
        })}
      </div>
      <CountriesDropdown
        selectCountry={selectCountry}
        countriesInfo={countriesInfo}
        countryImages={countryImages}
      />
    </div>
  );
};

export default memo(Countries);
